// vertical align function
$.fn.vAlign = function() {
    return this.each(function(i){
        var ah = $(this).height();
        var ph = $(this).parent().parent().height();        
        var mh = Math.ceil((ph-ah) / 2);
        $(this).css('margin-top', mh);
        // $(this).parent().parent().css('padding-top', mh );
    });
};